var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.149 6.94999C17.3409 7.03507 17.4912 7.19289 17.5667 7.38874C17.6423 7.58459 17.637 7.80243 17.552 7.99436L16.1911 11.0651C16.106 11.257 15.9482 11.4073 15.7524 11.4828C15.5565 11.5584 15.3387 11.5531 15.1468 11.4681L12.076 10.1072C11.8877 10.0198 11.7413 9.862 11.6683 9.66769C11.5952 9.47339 11.6014 9.25817 11.6855 9.06839C11.7696 8.87861 11.9249 8.72945 12.1179 8.65305C12.3109 8.57664 12.5262 8.5791 12.7174 8.6599L14.0409 9.24641L13.5889 8.075C12.5778 5.45447 9.55621 4.11542 6.93568 5.12654C4.31515 6.13766 2.97609 9.15926 3.98721 11.7798C4.99834 14.4003 8.01994 15.7394 10.6405 14.7283C10.8364 14.6527 11.0542 14.658 11.2462 14.7431C11.4382 14.8281 11.5885 14.986 11.664 15.1819C11.7396 15.3778 11.7343 15.5956 11.6492 15.7876C11.5642 15.9796 11.4063 16.1299 11.2104 16.2054C7.7745 17.5312 3.83577 15.7857 2.51003 12.3498C1.18428 8.91383 2.92977 4.9751 6.36571 3.64935C9.80164 2.32361 13.7404 4.0691 15.0661 7.50504L15.5181 8.67644L16.1046 7.35296C16.1897 7.16105 16.3475 7.01079 16.5434 6.93523C16.7392 6.85966 16.9571 6.86497 17.149 6.94999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.043973f5c83d6f7533dd758daab103fd.svg";
export { ForwardRef as ReactComponent };